import React, { createContext, useState, useEffect } from 'react';
import { getAccesToken, getUser } from '../Localstorage/localstorage';

// Create the AuthContext
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // Initialize from localStorage if available
    const [accessToken, setAccessToken] = useState(() => {
        const token = getAccesToken();
        return token || null;
    });
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        const token = getAccesToken();
        const user = getUser();
        return !!(token && user); // Authenticated if both token and user exist
    });

    // Sync with localStorage on mount
    useEffect(() => {
        const token = getAccesToken();
        const user = getUser();
        if (token && user) {
            setAccessToken(token);
            setIsAuthenticated(true);
        }
    }, []);

    // Function to log in and store the access token
    const login = (token) => {
        if (token) {
            setAccessToken(token);
            setIsAuthenticated(true);
        }
    };

    // Function to log out and clear the token
    const logout = () => {
        setAccessToken(null);
        setIsAuthenticated(false);
    };

    // Provide the state and functions to all children components
    return (
        <AuthContext.Provider value={{ accessToken, isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
